import { RuleEngineLegacyEntities } from '@bimser/components/dist/BCRuleManager';
import { IDictionary } from '@bimser/core';

export function getOperatorName(o: RuleEngineLegacyEntities.OperationType): string {
	const operators: IDictionary<string> = {
		Equals: 'equal', // (a, b) => a === b)
		NotEquals: 'notEqual', // (a, b) => a !== b)
		LessThan: 'lessThan', // (a, b) => a < b, numberValidator)
		LessThanOrEqual: 'lessThanInclusive', // (a, b) => a <= b, numberValidator)
		GreaterThan: 'greaterThan', // (a, b) => a > b, numberValidator))
		GreaterThanOrEqual: 'greaterThanInclusive', // (a, b) => a >= b, numberValidator))
		//Eklenen operatorler
		Null: 'null', // (a, b) => a === null
		NotNull: 'notNull', // (a, b) => a !== null
		StartsWith: 'startsWith', // (a, b) => a.startsWith(b)
		EndsWith: 'endsWith', // (a, b) => a.endsWith(b)
		Contains: 'contains', // (a, b) => a.indexOf(b) > -1
		NotContains: 'doesNotContain' // (a, b) => a.indexOf(b) === -1
	};

	return operators[o];
}
